import { activateI18n } from '@retail/funnel-components';
import { messages as sellOnlyMessages } from '../translations/AH-sell-only/sv-se/messages';
import { messages as retailMessages } from '../translations/autohero-common/sv-se/messages';

activateI18n('sv-SE', {
  ...retailMessages,
  ...sellOnlyMessages,
});
